import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { CONTENT_STANDARD, CONTENT_FULL } from '../../utils/media';
import theme from '../theme';
import { toRgba } from '../theme/colors';

const SubPageWrapper = styled.div`
  height: ${({ $position }) => `calc(100vh - ${$position}px)`};
  overflow: hidden;
  background-color: ${toRgba(theme.colors.NEU_50, 0.5)};
`;

const HeaderBand = styled.div`
  width: 100%;
  background-color: ${toRgba(theme.colors.NEU_50, 0.5)};
`;

const Header = styled.div`
  margin: auto;
  max-width: ${({ $size }) => ($size !== CONTENT_FULL ? `${$size}px` : $size)};
  padding: 0rem 1.5rem 1.5rem;
`;

const Scrollable = styled.div`
  overflow-y: scroll;
  height: 100%;
`;

const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 1rem 1.5rem 2rem;
  max-width: ${({ $size }) => ($size !== CONTENT_FULL ? `${$size}px` : $size)};
  gap: ${(props) => props.$gap || 0}px;
  align-items: ${({ $align }) => $align};
`;

const SubPage = ({ children, staticElements, align, gap, size }) => {
  const [position, setPosition] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    setPosition(ref?.current?.getBoundingClientRect().y);
  }, [ref?.current?.getBoundingClientRect()]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {staticElements && (
        <HeaderBand>
          <Header $size={size || CONTENT_STANDARD}>{staticElements}</Header>
        </HeaderBand>
      )}
      <SubPageWrapper ref={ref} $position={position}>
        <Scrollable>
          <PageContent $align={align || 'center'} $gap={gap} $size={size || CONTENT_STANDARD}>
            {children}
          </PageContent>
        </Scrollable>
      </SubPageWrapper>
    </>
  );
};

export default SubPage;
